import { render, staticRenderFns } from "./CustomerState.vue?vue&type=template&id=1f823406&scoped=true&"
import script from "./CustomerState.vue?vue&type=script&lang=ts&"
export * from "./CustomerState.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerState.vue?vue&type=style&index=0&id=1f823406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f823406",
  null
  
)

export default component.exports